<template>
  <div class="about-us">
    <Nav />
    <section class="hero" ref="hero">
      <div class="hero-content">
        <h1 class="ani-top">Leading Sustainable Innovations</h1>
        <p class="ani-bottom">
          <!-- xxx provides innovative, customizable polyurethane systems for diverse footwear needs,
          offering comfort, durability, and eco-friendly solutions tailored to various applications and climates. -->
        </p>
      </div>
      <div class="hero-bg">
        <img src="@/assets/banner.jpg" alt="QINYUAN GROUP company banner industrial raw material">
      </div>
    </section>
    <section class="intro" ref="intro">
      <div class="container">
        <div class="flex-row">
          <div class="intro-left ani-left">
            <div class="red-bar"></div>
          </div>
          <div class="intro-right ani-right">
            <p style="font-size:33px;font-weight:600;color:#d81f26">QINYUAN GROUP</p>
            <p style="font-size:20px;line-height:30px;"><br>IS FOCUS ON PROVIDE ONE STOP SERVICE FOR POLURETHANE INDUSTRIAL, <br>POLYVINYL
              CHLORIDE INDUSTRIAL, Ethylene-Vinyl Acetate Copolymer INDUSTRIAL, <br>WE PROVIDE CHEMICAL RAW
              MATERIAL,MACHINERY AND TECHNICAL SERVICE TO DIFFERENT APPLICATION, <br>LIKE FOR SHOES, FOR SYNTHETIC
              LEATHER ,FOR RIGID,SOFT PU FOAM,EVA SHEET, PVC BELT,AND ETC. <br><br>WE ESTABLISHED IN THE YEAR OF 2013, WITH
              13 YEARS HARD WORKING,<br>WE HAVE EXPORT OUR CARGOES TO MORE THAN 20 COUNTRIES,<br>LIKE THAILAND, INDIA
              ,VETNAN,INDONISIYA,PAKISTAN,DUBAI, IRAN,TURKEY,RUSSIA,MEXICO,<br>AND SO ON.AND WE GET A LOT OF GOOD
              FRIENDS FROM ALL OVER THE WORLD. <br>WE WILL CONTINUE OUR STEP TO PROVIDE GOOD SERVICE AS WELL AS HIGH
              QUALITY PRODUCTS. <br>HOPEFULLY ALL OF OUR CLENTS ENJOY WORKING WITH US.</p>
          </div>
        </div>
      </div>
    </section>
    <section class="journey" ref="journey">
      <div class="container">
        <h2 class="section-title ani-top">OUR JOURNEY OF GROWTH AND INNOVATION</h2>
        <div class="journey-timeline">
          <div class="timeline-line"></div>

          <div class="timeline-item right ani-right">
            <div class="timeline-dot"></div>
            <div class="timeline-content">
              <div class="timeline-img">
                <img src="@/assets/banner.jpg" alt="QINYUAN GROUP establishment history industrial raw material business">
              </div>
              <h3 class="timeline-year">2013-2014</h3>
              <p>Preparation was completed by the end of 2013.<br>
                QINYUAN INDUSTRIAL CORP established in 2014.<br>We specialize in exporting polyurethane synthetic leather, polyurethane
                shoe materials, chemical raw materials, and mechanical equipment.</p>
            </div>
          </div>

          <div class="timeline-item left ani-left">
            <div class="timeline-content">
              <div class="timeline-img">
                <img src="@/assets/banner.jpg" alt="QINYUAN expand southeast asia market chemical raw material export">
              </div>
              <h3 class="timeline-year">2015</h3>
              <p>Expand the Southeast Asian market, with an annual export value exceeding 10 million US dollars.</p>
            </div>
            <div class="timeline-dot"></div>
          </div>

          <div class="timeline-item right ani-right">
            <div class="timeline-dot"></div>
            <div class="timeline-content">
              <div class="timeline-img">
                <img src="@/assets/banner.jpg" alt="QINYUAN develop india pakistan market industrial materials">
              </div>
              <h3 class="timeline-year">2016</h3>
              <p>Expanding into the Indian and Pakistani markets, our products have received high praise and our company
                is developing steadily.</p>
            </div>
          </div>

          <div class="timeline-item left ani-left">
            <div class="timeline-content">
              <div class="timeline-img">
                <img src="@/assets/banner.jpg" alt="QINYUAN middle east market expansion dubai iran turkey">
              </div>
              <h3 class="timeline-year">2017</h3>
              <p>Develop the markets in Dubai, Iran and Türkiye in the Middle East, and officially launch overseas
                companies.</p>
            </div>
            <div class="timeline-dot"></div>
          </div>

          <div class="timeline-item right ani-right">
            <div class="timeline-dot"></div>
            <div class="timeline-content">
              <div class="timeline-img">
                <img src="@/assets/banner.jpg" alt="QINYUAN group company qualification grade a taxpayer">
              </div>
              <h3 class="timeline-year">2018</h3>
              <p>Obtained A-level taxpayer status in Shanghai.</p>
            </div>
          </div>

          <div class="timeline-item left ani-left">
            <div class="timeline-content">
              <div class="timeline-img">
                <img src="@/assets/banner.jpg" alt="QINYUAN customs statistics sample enterprise chemical industry">
              </div>
              <h3 class="timeline-year">2019</h3>
              <p>The enterprise has been selected as a sample enterprise for customs statistics.<br>SHANGHAI NEW ELEMENT CHEMICAL CO.,LTD ESTABLISHED.</p>
            </div>
            <div class="timeline-dot"></div>
          </div>

          <div class="timeline-item right ani-right">
            <div class="timeline-dot"></div>
            <div class="timeline-content">
              <div class="timeline-img">
                <img src="@/assets/banner.jpg" alt="QINYUAN export business breakthrough global raw material trade">
              </div>
              <h3 class="timeline-year">2023</h3>
              <p>CNH INDUSTRIAL LIMITED ESTABLISHED.<br>More than 30 export countries and an annual export value exceeding 40 million US dollars.</p>
            </div>
          </div>

          <div class="timeline-item left ani-left">
            <div class="timeline-content">
              <div class="timeline-img">
                <img src="@/assets/banner.jpg" alt="HUACHEM INDUSTRIAL LIMITED establishment overseas layout">
              </div>
              <h3 class="timeline-year">2024</h3>
              <p>HUACHEM INDUSTRIAL LIMITED ESTABLISHED.</p>
            </div>
            <div class="timeline-dot"></div>
          </div>
              <div class="timeline-item right ani-right">
            <div class="timeline-dot"></div>
            <div class="timeline-content">
              <div class="timeline-img">
                <img src="@/assets/banner.jpg" alt="QINYUAN group diversified development global industrial service">
              </div>
              <h3 class="timeline-year">2025</h3>
              <p>Responding to changes in international forms, diversified development of enterprises has been put on
                the agenda.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="leaders" ref="leaders">
      <div class="container">
        <h2 class="section-title ani-top">MEET OUR LEADERS</h2>
        <div class="leader-card main">
          <div class="leader-image ani-left ani-scale" style="width:500px;height:500px;">
            <img src="@/assets/banner.jpg" alt="JackNi director of QINYUAN GROUP polyurethane industry expert" >
          </div>
          <div class="leader-info red ani-right">
            <p>Mr.JackNi is a first-generation entrepreneur with over 15 years of experience in the Polyurethane industry and PVC industry and has been instrumental in driving innovation and growth in this industry.
              He identified key industry challenges - helping industry update and connect  Chinese products going to the World.</p>
           <br>
              <h3>JackNi</h3>
            <p style="font-size:16px">Director  QINYUAN</p>
          </div>
        </div>
        <div class="leaders-grid">
          <div class="leader-card ani-bottom ani-scale">
            <div class="leader-image">
              <img src="@/assets/banner.jpg" alt="industrial industry cooperation partner global raw material business">
            </div>
            <!-- <div class="leader-info red">
              <h3>Ankit Goel</h3>
              <p>Chairman and Founder, Space World Group</p>
              <p>Ankit Goel is the Founder and Chairman of Space World Group, a pioneering conglomerate dedicated to
                transforming the connectivity landscape of India. Under Ankit's visionary leadership, Space World Group
                has expanded into multiple sectors and its ventures have now become trusted brands.Radhey has won
                prestigious awards Economic Times' 'Most Promising Business Leaders of Asia' and CMO Asia's
                'Entrepreneur'</p>
            </div> -->
          </div>
          <div class="leader-card ani-bottom ani-scale" style="transition-delay:0.1s">
            <div class="leader-image">
              <img src="@/assets/banner.jpg" alt="overseas business partner chemical raw material trade partner">
            </div>
            <!-- <div class="leader-info red">
              <h3>Radhey R Sharma</h3>
              <p>Director and Co-Founder, Space World Group</p>
              <p>Radhey R Sharma is the Co-Founder and Director of Space World Group. He is known for his exceptional
                project management skills, turning challenges into opportunities. Radhey has been deeply engaged with
                emerging technologies, in academia and as an entrepreneur, building innovative growth ventures. He holds
                an impressive track record of leading strategic planning, pioneering Telecom projects .</p>
            </div> -->
          </div>
        </div>
      </div>
    </section>
    <section class="values" ref="values">
      <div class="container">
        <div class="values-grid">
          <div class="value-card ani-bottom ani-scale">
            <div class="value-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D81F26" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
            </div>
            <h3>VISION</h3>
            <p>Innovating for a Sustainable Future</p>
          </div>
          <div class="value-card ani-bottom ani-scale" style="transition-delay:0.1s">
            <div class="value-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D81F26" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <polygon
                  points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                </polygon>
              </svg>
            </div>
            <h3>MISSION</h3>
            <p>Our mission is to be the world's leading company in materials science through cutting-edge research &
              development, innovation, sustainability, inclusivity, and steadfast customer centricity.</p>
          </div>
          <div class="value-card ani-bottom ani-scale" style="transition-delay:0.2s">
            <div class="value-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D81F26" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z">
                </path>
              </svg>
            </div>
            <h3>VALUES</h3>
            <p>At QINYUAN, IACES - Innovation, Agility, Customer Centricity, Excellence, and Sustainability - forms the
              foundation of everything we do.</p>
          </div>
        </div>
      </div>
    </section>
    <section class="certificates" ref="certificates">
      <div class="container">
        <div class="cert-carousel-wrap">
          <div class="certificates-grid ani-scale">
            <img src="@/assets/banner.jpg" alt="QINYUAN GROUP enterprise qualification certificate chemical industry" class="cert-img">
            <img src="@/assets/banner.jpg" alt="global trade export certification industrial raw material business" class="cert-img">
            <img src="@/assets/banner.jpg" alt="chemical raw material production qualification certificate" class="cert-img">
            <img src="@/assets/banner.jpg" alt="overseas market trade qualification certificate" class="cert-img">
            <img src="@/assets/banner.jpg" alt="industry standard certification for polyurethane PVC materials" class="cert-img">
            <img src="@/assets/banner.jpg" alt="enterprise honor certificate global supplier award" class="cert-img">
            <img src="@/assets/banner.jpg" alt="QINYUAN GROUP enterprise qualification certificate chemical industry" class="cert-img">
            <img src="@/assets/banner.jpg" alt="global trade export certification industrial raw material business" class="cert-img">
            <img src="@/assets/banner.jpg" alt="chemical raw material production qualification certificate" class="cert-img">
            <img src="@/assets/banner.jpg" alt="overseas market trade qualification certificate" class="cert-img">
            <img src="@/assets/banner.jpg" alt="industry standard certification for polyurethane PVC materials" class="cert-img">
            <img src="@/assets/banner.jpg" alt="enterprise honor certificate global supplier award" class="cert-img">
          </div>
        </div>
      </div>
    </section>
    <section class="policies" ref="policies">
      <div class="container">
        <h2 class="section-title ani-top" style="font-size:40px;">QINYUAN</h2>
        <h2 class="ani-top" style="text-align:center;margin:-50px 0 30px 0;font-size:40px;"> CODE AND POLICIES
        </h2>
        <p class="policies-intro ani-top">These comprehensive documents serve as an ethical framework for QINYUAN,
          providing clear guidelines for how its employees and entities are expected to conduct business with integrity
          and responsibility.</p>
        <div class="policies-grid">
          <div class="policy-card ani-bottom ani-scale">
            <img src="@/assets/banner.jpg" alt="QINYUAN group business conduct ethics rule">
            <h3>Code of Business Conduct and Ethics</h3>
          </div>
          <div class="policy-card ani-bottom ani-scale" style="transition-delay:0.1s">
            <img src="@/assets/banner.jpg" alt="enterprise internal supervision whistle blower policy">
            <h3>Whistle Blower Policy</h3>
          </div>
          <div class="policy-card ani-bottom ani-scale" style="transition-delay:0.2s">
            <img src="@/assets/banner.jpg" alt="international trade anti bribery and corruption regulation">
            <h3>Anti Bribery and Corruption</h3>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  mounted() {
    // 专属页面SEO 标题+描述+关键词 谷歌/百度双收录
    document.title = "ABOUT QINYUAN GROUP | Professional Polyurethane PVC EVA Raw Material Supplier In China";
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "QINYUAN GROUP founded in 2013, provides one-stop service for polyurethane, PVC and EVA industry. Supply chemical raw materials, machinery equipment and technical service, export products to more than 20 countries worldwide.";

    let metaKey = document.querySelector('meta[name="keywords"]');
    if (!metaKey) {
      metaKey = document.createElement("meta");
      metaKey.name = "keywords";
      document.head.appendChild(metaKey);
    }
    metaKey.content = "QINYUAN GROUP,polyurethane raw material,PVC industrial material,EVA copolymer material,chemical raw material exporter,shoe industry raw material,synthetic leather material";

    this.observeScroll();
  },
  methods: {
    observeScroll() {
      const sections = [
        this.$refs.hero,
        this.$refs.intro,
        this.$refs.journey,
        this.$refs.leaders,
        this.$refs.values,
        this.$refs.certificates,
        this.$refs.policies,
      ];
      const handleScroll = () => {
        sections.forEach((section) => {
          if (!section) return;
          const rect = section.getBoundingClientRect();
          const isInView =
            rect.top < window.innerHeight * 0.8 && rect.bottom > 0;
          if (isInView) section.classList.add("active");
        });
      };
      window.addEventListener("scroll", handleScroll);
      handleScroll();
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("scroll", handleScroll);
      });
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 0px;
  box-sizing: border-box;
}
.hero .hero-content {
  position: absolute;
  top: 50%;
  left: 224px;
  transform: translateY(-50%);
  max-width: 45%;
  z-index: 2;
}
.hero {
  background: transparent;
  color: #fff;
  padding: 0;
  height: 480px;
  position: relative;
  overflow: hidden;
  min-width: 1200px;
}
.hero .hero-content h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.3;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.hero .hero-content p {
  font-size: 1.1rem;
  opacity: 0.9;
}
.hero .hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.hero .hero-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hero::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(
    90deg,
    #d81f26 0%,
    #d81f26 40%,
    rgba(216, 31, 38, 0) 100%
  );
  z-index: 1;
}
.intro {
  padding: 2rem 0;
  background-color: #f8f8f8;
}
.flex-row {
  display: flex;
  gap: 2rem;
  align-items: center;
}
.flex-row.reverse {
  flex-direction: row-reverse;
}
.intro-left {
  flex: 1;
}
.red-bar {
  position: relative;
  width: 440px;
  height: 430px;
  box-sizing: border-box;
  border-left: 9px solid #d81f26;
  border-bottom: 9px solid #d81f26;
  margin-bottom: 0;
  margin-top: 70px;
  transition: all 0.9s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.intro-right {
  flex: 2;
}
.journey {
  padding: 6rem 0;
  margin: 0 0 120px 0;
  position: relative;
  background-color: #fff;
}
.section-title {
  color: #d81f26;
  font-weight: 700;
  margin-bottom: 4rem;
  font-size: 58px;
  text-align: center;
}
.journey-timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 0;
}
.timeline-line {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #f0f0f0;
  transform: translateX(-50%);
  z-index: 1;
}
.timeline-item {
  display: flex;
  align-items: center;
  margin-bottom: -11rem;
  position: relative;
  z-index: 2;
}
.timeline-item.left {
  flex-direction: row-reverse;
}
.timeline-content {
  width: 45%;
  background: #ffffff;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.timeline-content:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
}
.timeline-img {
  width: 100%;
  height: 220px;
  border-radius: 12px;
  overflow: hidden;
}
.timeline-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}
.timeline-content:hover .timeline-img img {
  transform: scale(1.08);
}
.timeline-year {
  color: #d81f26;
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0.5px;
}
.timeline-content p {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #555;
  margin: 0;
  flex: 1;
}
.timeline-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #d81f26;
  border: 5px solid #ffffff;
  box-shadow: 0 0 0 4px #f0f0f0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  transition: all 0.3s ease;
}
.timeline-item:hover .timeline-dot {
  box-shadow: 0 0 0 6px rgba(216, 31, 38, 0.2);
}
.leader-card.main {
  width: 1000px;
  height: 500px;
  margin: 0 auto 36px;
}
.leaders {
  padding: 3rem 0;
  background-color: #f8f8f8;
}
.leader-card {
  display: flex;
  height: 470px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  margin:0 3px;
}
.leader-image {
  width: 100%;
  overflow: hidden;
}
.leader-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}
.leader-card:hover .leader-image img {
  transform: scale(1.05);
}
.leader-info {
  padding: 2rem;
  flex: 1;
  font-size:1.3rem;
  font-weight: 400;
  line-height: 37px;
}
.leader-info.red {
  background-color: #d81f26;
  color: #fff;
}
.leader-info h3 {
  margin-bottom: 0.5rem;
  font-size: 1.7rem;
}
.leader-info p:first-of-type {
  margin-bottom: 1rem;
}
.leaders-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
}
.values {
  padding: 4rem 0 6rem 0;
}
.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}
.value-card {
  text-align: center;
  padding: 2.5rem 2rem;
  background-color: #f8f8f8;
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.value-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}
.value-icon {
  margin-bottom: 1.5rem;
}
.value-card h3 {
  color: #d81f26;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}
.certificates {
  padding: 6rem 0;
  margin: -30px 0 30px 0;
  background-color: #f8f8f8;
  overflow: hidden;
}
.cert-carousel-wrap {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 0 20px;
}
.certificates-grid {
  display: flex;
  gap: 2rem;
  animation: certScroll 25s linear infinite;
  flex-shrink: 0;
  width: max-content;
}
.cert-carousel-wrap:hover .certificates-grid {
  animation-play-state: paused;
}
.cert-img {
  width: 300px;
  height: 460px;
  flex-shrink: 0;
  border-radius: 6px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}
.cert-img:hover {
  transform: scale(1.02);
}
@keyframes certScroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-50% - 1rem));
  }
}
.policies {
  padding: 0 0 40px 0;
  margin:40px 0 50px 0;
}
.policies-intro {
  text-align: center;
  max-width: 1500px;
  margin: 0 auto 4rem;
  font-size: 20px;
  color:#000000aa;
}
.policies-grid {
  display: grid;
  height: 400px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}
.policy-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: transform 0.3s ease;
}
.policy-card:hover {
  transform: translateY(-5px);
}
.policy-card img {
  width: 100%;
  height: 300px;
  object-fit: cover;
}
.policy-card h3 {
  padding: 1.5rem 1rem 0;
  font-size: 1.1rem;
  color: #333;
}
.btn {
  display: inline-block;
  padding: 0.8rem 2rem;
  background-color: #d81f26;
  color: #fff;
  border-radius: 4px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 1.5rem 0 2rem;
}
.btn:hover {
  background-color: #b91c1c;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(216, 31, 38, 0.2);
}
.ani-top {
  opacity: 0;
  transform: translateY(120px);
  transition: all 1.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.ani-bottom {
  opacity: 0;
  transform: translateY(120px);
  transition: all 1.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.ani-left {
  opacity: 0;
  transform: translateX(-180px);
  transition: all 1.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.ani-right {
  opacity: 0;
  transform: translateX(180px);
  transition: all 1.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.ani-scale {
  opacity: 0;
  transform: scale(0.6);
  transition: all 1.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.active .ani-top,
.active .ani-bottom,
.active .ani-left,
.active .ani-right {
  opacity: 1;
  transform: translate(0);
}
.active .ani-scale {
  opacity: 1;
  transform: scale(1);
}
/* 全局移动端适配 已完善 不改动原有样式逻辑 */
@media (max-width: 992px) {
  .nav-links {
    display: none;
  }
  .hero {
    height: auto;
    flex-direction: column;
    min-width: auto;
  }
  .hero-content {
    width: 100%;
    height: auto;
    padding: 2rem;
    text-align: center;
    left: 0;
    max-width: 100%;
  }
  .hero-image {
    width: 100%;
    height: 400px;
    position: relative;
  }
  .hero-title {
    font-size: 2rem;
  }
  .flex-row {
    flex-direction: column;
  }
  .flex-row.reverse {
    flex-direction: column;
  }
  .leader-card {
    flex-direction: column;
    height: auto;
  }
  .leader-image {
    width: 100%;
    height: 300px;
  }
  .leaders-grid {
    grid-template-columns: 1fr;
  }
  .leader-card.main {
    width: 100%;
    height: auto;
  }
  .timeline-line {
    left: 30px;
  }
  .timeline-item {
    flex-direction: column !important;
    align-items: flex-start !important;
    padding-left: 60px;
    margin-bottom: 1.4rem;
  }
  .timeline-content {
    width: 100% !important;
    margin-bottom: 1rem;
  }
  .timeline-dot {
    left: 30px !important;
  }
  .timeline-img {
    height: 160px;
  }
  .policies-grid {
    height: auto;
  }
}
@media (max-width: 768px) {
  .cert-img {
    width: 220px;
  }
  .cert-carousel-wrap {
    padding: 0 10px;
  }
  .section-title {
    font-size: 48px;
    margin-bottom: 2rem;
  }
  .journey {
    padding: 4rem 0;
  }
  .timeline-img {
    height: 140px;
  }
}
@media (max-width: 480px) {
  .cert-img {
    width: 180px;
  }
  .certificates-grid {
    gap: 1rem;
  }
  .red-bar {
    width: 200px;
    height: 200px;
  }
  .timeline-img {
    height: 120px;
  }
  .timeline-content {
    padding: 1.5rem;
  }
}
</style>